import api from './api';

const projectionService = {
  get: async () => {
    const res = await api.get('/projections');
    return res.data;
  },
};

export default projectionService;
